var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSearch(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.7745 16.7144L12.6574 11.5973C13.6486 10.3729 14.2454 8.81715 14.2454 7.12271C14.2454 3.19548 11.0499 0 7.12268 0C3.19544 0 0 3.19544 0 7.12268C0 11.0499 3.19548 14.2454 7.12271 14.2454C8.81715 14.2454 10.3729 13.6486 11.5973 12.6574L16.7144 17.7745C16.8606 17.9207 17.0525 17.9942 17.2444 17.9942C17.4364 17.9942 17.6283 17.9207 17.7745 17.7745C18.0677 17.4814 18.0677 17.0075 17.7745 16.7144ZM7.12271 12.7459C4.0217 12.7459 1.49953 10.2237 1.49953 7.12268C1.49953 4.02167 4.0217 1.49949 7.12271 1.49949C10.2237 1.49949 12.7459 4.02167 12.7459 7.12268C12.7459 10.2237 10.2237 12.7459 7.12271 12.7459Z",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.6ee15a70.svg";
export { ForwardRef as ReactComponent };